/**
 * @description Authentication Store Module
 * @author Fahid Mohammad
 */

import http from '../../util/axios'
const VueCookie = require('vue-cookie') // using require to avoid SSR rejection
import config from '../../../config/endpoints.js'
const AUTH_URL = config.auth_url

export default {
    namespaced: true,
    state: {
        isLoggedIn:false,
        isLoading:false,
        token:"",
        userId:"",
        userData: null,
        isNotified: true
    },
    mutations:{
        addIsLoggedIn: (state, status) => {
            state.isLoggedIn = status
        },
        removeIsLoggedIn: (state) => {
            state.isLoggedIn = false
        },
        addLogin: (state, {status, token}) => {
            state.isLoggedIn = status
            state.token = token
        },
        userdetails: (state, userdetails) => {
            state.userdetails = userdetails
        },
        setLoading: (state, status) => {
            state.isLoading = status
        },
        setUserData: (state, status) => {
            state.userData = status
        },
        setNavigation: (state, status) => {
            state.isNotified = status
        }
    },
    actions:{
        SET_ISLOGGEDIN({ commit }, status) {
            commit('addIsLoggedIn', { status })
        },
        LOGIN_REQUEST({ commit }, form) {
            commit('setLoading', true)
            return http.post(AUTH_URL + "/opt/login", form).then(response => {
                commit('setLoading', false)
                let status = false, token = null;
                if(response.status===1000){
                    status = true; token = response.token;
                    //  Commit to store
                    commit('addLogin', { status, token })
                    commit('setUserData', response.userdata)
                    commit('addIsLoggedIn', true)
                    //  Set cookie
                    VueCookie.set('token',token);
                    localStorage.setItem('fnids',JSON.stringify(response.f));
                    localStorage.setItem('userdetails',JSON.stringify(response.userdata))
                  /*   VueCookie.set('userdetails',JSON.stringify(response.userdata)); */
                    localStorage.setItem('eventids',JSON.stringify(response.e));
                    localStorage.setItem('menu',JSON.stringify(response.menuList));
                    return response
                }else{
                    return {status:response.status, message:response}
                }
            })
        },
        CHANGEPASSWORD_REQUEST({ commit }, form) {
            return http.post("/employee/changePassword", form).then(response => {
                let _self = this;
                if(response.status===1000){
                    return {status: true, message: response.message}
                }else{
                    return {status: false, message:response.error};
                }
            })
        },
        UPDATE_LOGIN({ commit }, {status, token}) {
            commit('addLogin', { status, token })
        },
        LOGOUT({commit}){
            return new Promise((resolve, reject) => {
                VueCookie.delete('token');
                let status = false, token = null;
                localStorage.clear();
                commit('addLogin', { status, token })
                commit('userdetails', null)
                setTimeout(function(){ // to avoid glitch in SSR router push
                    resolve(true)
                },200)
            })
        },
    },
    getters:{
        getLoginStatus: state => state.isLoggedIn,
        getToken : state =>{
            return state.token
        },
        getUserData: state => state.userData,
        getNavigation: state =>  { 
            return state.isNotified 
        }
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js